import _ from 'lodash'

import type Field from 'modules/reports/store/models/Field'
import { default as FieldModel } from 'modules/reports/store/models/Field'

/**
 * Group fields by categories and subcategories
 */
export function groupByCategory(fields: Field[]): FieldModel[] {
  const byCategory = _.groupBy(fields, (f) => f.attributes.category_label)

  return _.flatMap(byCategory, (value, _key) => {
    const groupedFields = _.flatMap(_.groupBy(value, (field) => field.attributes.subcategory_label))

    return groupedFields
  })
}

export function fieldsCategories(fields: Field[]) {
  const categoryTree: Record<string, string[]> = {}
  const byCategory = _.groupBy(fields, (f) => f.attributes.category_label)

  _.forEach(byCategory, (value, key) => {
    const subCategories = _.flatMap(
      _.groupBy(value, (f) => f.attributes.subcategory_label),
      (v, k) => k
    )

    categoryTree[key] = _.compact(subCategories)
  })

  return categoryTree
}
